module.exports = __webpack_public_path__ + "static/media/special_6.f5824056.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_6.csv
// module id = 742
// module chunks = 0